import modulpack from "../../../../assets/images/productos/modulpack36r/MODULPACK - 1.png";
import qr from "../../../../assets/images/QR Daniel Montes.svg";
import Producto from "../../../../components/producto";

import pic1 from "../../../../assets/images/productos/modulpack36r/Mosaico - MP1.png";
import pic2 from "../../../../assets/images/productos/modulpack36r/Mosaico - MP2.png";

import { useTranslation } from "react-i18next";

function Modulpack36r() {

  const {t} = useTranslation();

  return (
    <Producto
      fotos={[pic1, pic2]}
      datosTabla1={[
        [t("tensionNominal"), "kV", "36"],
        [t("corrienteNominal"), "A", "1.250 / 2.000 / 2.500 / 3.150"],
        [t("corrienteBreveDuracion"), "kA", "20 / 25 / 31,5"],
        [t("corrienteDinamica"), "kA", "63 / 78 / 100"],
        [t("nivelDeAislacion"), "kV", "70"],
        [t("tensionDeImpulso"), "kV", "170"],
        [t("frecuenciaNominal"), "Hz", "50 / 60"],
      ]}
      datosTabla2={[
        [t("ancho"), "mm", "1.000"],
        [t("alto"), "mm", "2.950"],
        [t("profundidad"), "mm", "2.630"],
      ]}
      nombreProducto={"Modulpack 36R"}
      fotoProducto={modulpack}
      descripcionProducto={t("modulpack36R.titulo_descripcion")}
      caracteristicas={[
        t("modulpack36R.bullet1"),
        t("modulpack36R.bullet2"),
        t("modulpack36R.bullet3"),
        t("modulpack36R.bullet4"),
        t("modulpack36R.bullet5"),
        t("modulpack36R.bullet6"),
        t("modulpack36R.bullet7"),
        t("modulpack36R.bullet8"),
        t("modulpack36R.bullet9")
      ]}
      vendedor={{
        nombre: "Daniel Montes",
        telefono: "+54 9 11 3167-6868",
        mail: "dmontes@ema.com.ar",
        qr: qr,
      }}
      pathPdf={'/assets/docs/2025%20-%20Modulpack%2036%20R.pdf'}
    />
  );
}

export default Modulpack36r;
